const waterIntake = ["0-2", "3-5", "6-8", "8-11", "Más de 11"];
export default waterIntake;
